var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.709,
    height: 24.714,
    viewBox: "0 0 24.709 24.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "audio-waves",
    d: "M14.192,24.715a2.816,2.816,0,0,1-2.311-1.2,2.855,2.855,0,0,1-.539-1.675V2.8a.664.664,0,0,0-.067-.29l-.033-.068a.869.869,0,0,0-1.019-.479.883.883,0,0,0-.715.9V17.042a2.847,2.847,0,0,1-5.695,0V8.432A.941.941,0,0,0,2.2,7.77a.935.935,0,0,0-.272.661v7.115a.965.965,0,0,1-1.93,0V8.432A2.854,2.854,0,0,1,.829,6.414a2.826,2.826,0,0,1,3.134-.639A2.825,2.825,0,0,1,5.743,8.432v8.611a.912.912,0,0,0,.26.64.917.917,0,0,0,1.573-.64V2.856A2.8,2.8,0,0,1,9.788.079a2.788,2.788,0,0,1,3.188,1.514l.033.069A2.608,2.608,0,0,1,13.272,2.8V21.84a.936.936,0,0,0,.177.549.888.888,0,0,0,.767.4.937.937,0,0,0,.939-.944V20.469a.965.965,0,0,1,1.93,0V21.84a2.868,2.868,0,0,1-2.825,2.874h-.067Zm7.671-4.826a2.812,2.812,0,0,0,2.516-1.536,2.885,2.885,0,0,0,.331-1.338V10.141a.965.965,0,0,0-1.93,0v6.874a.945.945,0,0,1-.108.439.876.876,0,0,1-.809.506h0a1.018,1.018,0,0,1-.678-.256.889.889,0,0,1-.285-.688V8.431a2.871,2.871,0,1,0-5.743,0v7.212a.965.965,0,1,0,1.93,0V8.431a.937.937,0,0,1,.438-.8.941.941,0,0,1,1.444.8v8.584a2.818,2.818,0,0,0,.918,2.118,2.97,2.97,0,0,0,1.975.757Zm0,0",
    transform: "translate(0 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoost);
export default __webpack_public_path__ + "static/media/boost.8b567788683e1b73fa1133ab0782c9c9.svg";
export { ForwardRef as ReactComponent };